module.exports = __webpack_public_path__ + "static/Muli-Black-95a6b5b148dc2a74e83392826e484ed0.woff";